const regexes: Record<string, RegExp> = {
  // https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
  email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])*$/
}

export { regexes }
